<template lang='html'>
  <label>
    <input class='test_radioinput' type='radio' name='question' :value='answer' @change='selectAnswer($event.target.value)'>
    <div class='test_radioinput_custom'></div>
    <div class='test_question_answer'>{{answer}}</div>
  </label>
</template>

<script>
import axios from 'axios';

export default {
  name: 'answer-option',

  props: {
    answer: {
      type: String,
      default: ''
    }
  },

  methods: {
    selectAnswer(answer) {
      this.$emit('onSelectAnswer', answer)
    }
  },

  mounted() {
  }
}
</script>

<style lang='scss'>
  $blue: #00bcc6;
  $orange: #f7941d;

  .test_radioinput {
    display: none;
  }

  .test_radioinput_custom {
    width: 20px;
    height: 20px;
    border: 1px solid $blue;
    border-radius: 50%;
    margin-right: 20px;
    position: relative;
    background-color: white;
  }

  .test_radioinput:checked + .test_radioinput_custom::before {
    content: '';
    display: block;
    position: absolute;
    width: 12px;
    height: 12px;
    top: -2px;
    left: -2px;
    border: 6px solid $orange;
    border-radius: 50%;
  }

  .test_question_answer {
    width: calc(100% - 45px);
  }

  @media (min-width: 768px) {
    .test-wrapper .test_question {
        width: auto !important;
    }
  }

</style>



// WEBPACK FOOTER //
// src/components/AnswerOption.vue